import { VoidReturn } from '../../../Utils/PageUtils';
import { useNavigate } from 'react-router-dom';

export type PageNotFoundDialogHandler = {
    backToOrionNow: () => VoidReturn;
};

function usePageNotFoundDialogHandler(): PageNotFoundDialogHandler {
    const navigate = useNavigate();

    const backToOrionNow = () => {
        navigate('/');
    };

    return {
        backToOrionNow,
    };
}

export default usePageNotFoundDialogHandler;
